export default {
  //TODO: REMOVE AND USE NEW TRANSLATIONS
  HERES_A_PREVIEW: `Here's a preview of your audio & video`,
  TURN_OFF_AV_WHILE_WAITING: `Turn off audio & video while waiting`,
  TURN_ON_AV_WHILE_WAITING: `Turn on audio & video while waiting`,
  GOTO_AV_SETTINGS: `Go to Audio & Video Settings`,
  SIT_TIGHT: `Please sit tight`,
  WE_WILL_CONNECT_AUTOMATICALLY: `
  We'll connect you automatically
  as soon as we're ready for you.`,
  REPORT_TECHNICAL_ISSUE: `Report a Technical Issue`,
  CAMERA_NOT_SELECTED1: `You haven't chosen a camera`,
  CAMERA_NOT_SELECTED2: `Please choose a camera`,
  CAMERA_NOT_FOUND1: `We can't find a camera on your device`,
  CAMERA_NOT_FOUND2: `Your call will be audio only`,
  CAMERA_LOADING: `Camera loading...`,

  WAITING_ROOM_APPT_DETAILS: `You’re set up.`,
  WAITING_ROOM_APPT_BREATH: `Take a breath`,
  WAITING_ROOM_INSTRUCTION_1: `Stay on this waiting room page.`,
  WAITING_ROOM_INSTRUCTION_2: `Your call will start when your care team is ready.`,
  WAITING_ROOM_SIGNPOST_CONNECTIVITY: `Pro tip - is your internet connection as strong as it could be? If not, move closer to your WiFi router.`,
  WAITING_ROOM_SIGNPOST_PRIVACY: `Pro tip - are you in a private place? If not, move somewhere you are comfortable asking questions about your health.`,
  WAITING_ROOM_SIGNPOST_STREAMING: `Pro tip - is someone else sharing your internet bandwidth? Make sure no one is streaming video or playing video games.`,
  WAITING_ROOM_SIGNPOST_UNUSED_TABS: `Pro tip - have you closed any unused apps and browser tabs? Make sure your bandwidth is as strong as it can be.`,
  WAITING_ROOM_SIGNPOST_DO_NOT_DISTURB: `Pro tip - enable ‘Do Not Disturb’ on your device for at least 1 hour to avoid dropping out if someone calls you.`,
  WAITING_ROOM_BANNER_HEADER: `Your care team is ready`,
  WAITING_ROOM_BANNER_CONTENT: `Joining the call now ...`,
  WAITING_ROOM_CUT_OFF_DETAILS: `<0>One moment please.</0>
    <1>You were cut off</1>`,
  WAITING_ROOM_CUT_OFF_INSTRUCTION: `Please stay on this page as we work on getting you back on the call.`,
  // NEW TRANSLATIONS
  WAITING_ROOM_WELCOME: `Welcome {{patientName}},`,
  WAITING_ROOM_MAIN_TEXT: `Take a breath, your call will start shortly.`,
  WAITING_ROOM_SUB_TEXT: `Stay on this page, and your call will start when your care team is ready.`,

  // TODO: deprecate this key along with WaitingRoomPageV2
  WAITING_ROOM_ONE_WAY_MESSAGE_PROVIDER_DELAYED_TAG: `We apologize for the delay`,

  // WaitingRoomPageV3 keys
  WAITING_ROOM_STATUS_CONFIRM: `You're set up`,
  WAITING_ROOM_STATUS_VISITTIME: `Your visit should start soon`,
  WAITING_ROOM_STATUS_WAITTIME: `Your visit should start soon`,
  WAITING_ROOM_STATUS_AUTODELAY: `We apologize for the delay`,
  WAITING_ROOM_STATUS_DELAYED: `We apologize for the delay`,
  WAITING_ROOM_STATUS_SIT_TIGHT_TITLE: `Please sit tight`,
  WAITING_ROOM_STATUS_SIT_TIGHT_CONTENT: `Your care team can see that you're online.`,

  WAITING_ROOM_ONE_WAY_MESSAGE_PROVIDER_DELAYED_HEADER_TEXT: `Your care team is running a little late.`,
  WAITING_ROOM_ONE_WAY_MESSAGE_PROVIDER_DELAYED_SUB_TEXT: `We see that you’re online, and your call will start when your care team is ready.`,
  //Page Title
  WAITING_ROOM_TITLE: `Telehealth - Waiting Room`,
};
